import BaseAPI from '@/apis/base/baseApi';

export default class PlatformIntegrationApi extends BaseAPI {
  apiName = 'MisaPlatformIntegration';
  controllerName = 'Accounts';

  constructor() {
    super();
  }
}
